<template>
  <div class="carousel-wrapper position-relative">
    <b-carousel
      ref="carousel"
      id="carousel-ja"
      :interval="interval"
      background="#ababab"
      img-width="1024"
      img-height="480"
    >
      <b-carousel-slide
        v-for="(carousel, index) in carousels"
        :key="index"
        :img-src="domainUrl(carousel.imageUrl)"
      >
        <h3 class="text-secondary"  v-if="carousel.title">{{ carousel.title }}</h3>
        <div class="text-dark" v-if="carousel.introduction" v-html="carousel.introduction"></div>
      </b-carousel-slide>
    </b-carousel>
    <button class="custom-control prev" @click="prevSlide">
      <i class="fa-solid fa-chevron-left"></i>
    </button>
    <button class="custom-control next" @click="nextSlide">
      <i class="fa-solid fa-chevron-right"></i>
    </button>
  </div>
</template>

<script>
import { getCarousels } from "@/api/home";
export default {
  name: "CarouselView",
  data() {
    return {
      carousels: [],
      interval: parseInt(process.env.VUE_APP_HOME_CAROUSEL_INTERVAL)
    }
  },
  mounted() {
    this.getCarousels();
  },
  computed: {
    domain() {
      return process.env.VUE_APP_S3_DOMAIN || '';
    }
  },
  methods: {
    /** 查询所有走马灯列表 */
    async getCarousels() {
      try {
        this.carousels = await getCarousels();
      } catch (error) {
        console.error("走马灯列表获取失败:", error.message);
      }
    },
    domainUrl(path) {
      return `${this.domain}${path}`;
    },
    nextSlide() {
      this.$refs.carousel.next();
    },
    prevSlide() {
      this.$refs.carousel.prev();
    }
  }
}
</script>

<style scoped>
.carousel-wrapper {
  position: relative;
}

.custom-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: transparent;
  border: none;
  font-size: 2rem;
  color: #007bff;
  cursor: pointer;
  padding: 0.5rem;
  transition: color 0.3s;
}

.custom-control:hover {
  color: #0056b3;
}

.custom-control.prev {
  left: 10px;
}

.custom-control.next {
  right: 10px;
}
</style>
